/**
 * Список строк блока «Голоса клиента» слоями (#2060, спека
 * 2026-10-11-voice-report-layers.md §2.4): первые пять строк и «Показать все N».
 *
 * - Срез — только с `limit`: без него список целиком.
 * - `pageSize` — страницы с перелистыванием вместо среза (#2314,
 *   `VoicePagedList`): «Маркетинг» и «Продукт» — справочные списки до 30
 *   конкурентов, где «Показать все» вернуло бы ту же длинную ленту, под которой
 *   никто не видит сигналов. Порядок строк не меняется: нулевые — на последних
 *   страницах.
 * - Строки с нулём разговоров всегда под «Показать все», даже если ненулевых
 *   меньше пяти: «0 из 61» — тоже ответ, но не первый слой. Нули у всех строк
 *   (отказы без названной причины) — список не сворачивается: блок не остаётся
 *   пустым с одной кнопкой.
 * - Раскрытая по адресу строка, оказавшаяся за пятёркой, разворачивает
 *   список — при показе и при смене строк (взгляд «Рынок» → «Команда»): иначе
 *   «Назад» из разговора или переключатель открывали бы пустоту.
 */
import { VoiceFoldedList } from './VoiceFoldedList';
import { VoicePagedList } from './VoicePagedList';
import type { VoiceTopListProps } from './voice-top-list';

export { VOICE_PAGE_ROWS, VOICE_TOP_ROWS } from './voice-top-list';

export function VoiceTopList<T>(props: VoiceTopListProps<T>) {
  return props.pageSize === undefined ? (
    <VoiceFoldedList {...props} />
  ) : (
    <VoicePagedList {...props} pageSize={props.pageSize} />
  );
}
